import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const SORT_SCHEMA = Object.freeze({
  COLUMN: 0,
  ORDER: 'desc',
});
const RECORD = generateSchema(SORT_SCHEMA);
const KEYS: any = generateKeys(SORT_SCHEMA);

export class Sort extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get column(): number {
    return this.get(KEYS.COLUMN);
  }

  get order(): string {
    return this.get(KEYS.ORDER);
  }

  isDesc(): boolean {
    return this.order === 'desc';
  }
}
